import React, { useState, useEffect } from 'react';

const NotificationTable = ({ notifications }) => {
  const [sortedNotifications, setSortedNotifications] = useState([]);
  const [sortAsc, setSortAsc] = useState(false);

  useEffect(() => {
    const sorted = [...notifications].sort((a, b) =>
      sortAsc ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date)
    );
    setSortedNotifications(sorted);
  }, [notifications, sortAsc]);

  return (
    <table className="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Titulo</th>
          <th>Mensaje</th>
          <th
            onClick={() => setSortAsc(!sortAsc)}
            style={{ cursor: 'pointer', userSelect: 'none' }}>
            Fecha {sortAsc ? '↑' : '↓'}
          </th>
        </tr>
      </thead>
      <tbody>
        {sortedNotifications.map((notification) => (
          <tr key={notification.id}>
            <td>{notification.title}</td>
            <td>{notification.body}</td>
            <td>{notification.date}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default NotificationTable;
